module.exports = __webpack_public_path__ + "static/img/header_bg4.8c984a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/header/header_bg4.png
// module id = bm/g
// module chunks = 1